<template lang='pug'>
section
  v-card(class='auth-form')
    v-toolbar(flat color='white' prominent)
      v-toolbar-title Авторизация
    v-card-text(class='pb-4')
      v-form(@keyup.native.enter='tryLogin' ref='form')
        v-text-field(
          :error='errors.has(loginBy)'
          :error-messages='errors.first(loginBy)'
          class='mb-3'
          v-model='user.login'
          label='Логин'
          hint='Введите номер телефона или e-mail'
          persistent-hint
          type='text'
        )
        v-text-field(
          @click:append='passVisibility = !passVisibility'
          :type='passVisibility ? "text" : "password"'
          :error-messages='errors.first("password")'
          :error='errors.has("password")'
          :append-icon='passVisibility ? "visibility_off" : "visibility"'
          v-model="user.password"
          label='Пароль'
        )
        div(class='forgot')
          router-link(:to='{ name: "Auth.Reset" }') Забыли пароль?
    v-card-actions(class='card-actions')
      v-layout(column align-content-center)
        v-flex
          v-btn(
            @click='tryLogin'
            :loading='loading'
            color='primary'
            type='submit'
            block
          ) Войти
  v-layout(column align-center)
    div(class='pt-3')
      router-link(:to='{ name: "Auth.Register" }') Регистрация
</template>

<script>
import { isEmpty } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

export default {
  data: () => ({
    loading: false,
    passVisibility: false,
    loginBy: 'phone',
    user: {
      login: '',
      password: ''
    }
  }),

  methods: {
    async tryLogin() {
      let credentials = {
        password: this.user.password
      }

      if (isEmpty(this.user.login) || isEmpty(this.user.password)) {
        return
      }

      this.loading = true

      if (this.authenticated) {
        await this.tryLogout()
      }

      credentials[
        this.loginBy === 'email' ? 'email' : 'phone'
      ] = this.user.login

      try {
        await this.login(credentials)
      } catch (e) {
        this.$showServerErrors(e)
      } finally {
        this.loading = false
      }
    },

    async tryLogout() {
      try {
        await this.logout()
      } catch (e) {
        this.$log.error(e)
      }
    },

    ...mapActions('auth', ['login', 'logout'])
  },

  computed: mapGetters('auth', ['authenticated']),

  watch: {
    user: {
      deep: true,
      handler({ login }) {
        this.loginBy = /\S+@\S+/.test(login) ? 'email' : 'phone'
      }
    }
  }
}
</script>

<style scoped>
.forgot {
  text-align: right;
}
</style>
